import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Login from "./componentes/Login";
import Error from "./componentes/Error";
import NotFound from "./componentes/NotFound";
import Access from "./componentes/Access";
import Bienvenido from './componentes/Bienvenido';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';

function App() {    
    return (
    
    <BrowserRouter >
        <Switch>
            <Route path="/consultareciboquadrum" component={Login} exact />
            <Route path="/consultareciboquadrum/login" component={Login}/>
            <Route path="/consultareciboquadrum/bienvenido" component={Bienvenido} />
            <Route path="/consultareciboquadrum/error" component={Error}/>
            <Route path="/consultareciboquadrum/notfound" component={NotFound}/>
            <Route path="/consultareciboquadrum/access" component={Access}/>
        </Switch>
    </BrowserRouter>);
}

export default App;